import { Access } from '../../enums';
import { Permission } from '../permission';

const GENERAL_KEY = 'general';
export const GENERAL = {
  CASH_AMOUNT: {
    ADMINISTRATE: new Permission({
      key: `${GENERAL_KEY}:cash-amount-admin:${Access.WRITE}`,
      description: 'Barbetrag - Administrationsrecht',
    }),

    READ: new Permission({
      key: `${GENERAL_KEY}:cash-amount:${Access.READ}`,
      description: 'Barbetrag – Leserecht',
    }),

    WRITE: new Permission({
      key: `${GENERAL_KEY}:cash-amount:${Access.WRITE}`,
      description: 'Barbetrag - Schreibrecht',
    }),
  },

  CALENDAR: {
    READ: new Permission({
      key: `${GENERAL_KEY}:calendar:${Access.READ}`,
      description: 'Kalender – Leserecht',
    }),

    WRITE: new Permission({
      key: `${GENERAL_KEY}:calendar:${Access.WRITE}`,
      description: 'Kalender - Schreibrecht',
    }),

    CHANGE_ENTRIES: new Permission({
      key: `${GENERAL_KEY}:calendar-change-entries:${Access.WRITE}`,
      description: 'Kalendereinträge ändern',
    }),
  },

  CONTACTS: {
    READ: new Permission({
      key: `${GENERAL_KEY}:contacts:${Access.READ}`,
      description: 'Kontakte – Leserecht',
    }),

    WRITE: new Permission({
      key: `${GENERAL_KEY}:contacts:${Access.WRITE}`,
      description: 'Kontakte - Schreibrecht',
    }),
  },

  MESSAGES: {
    READ: new Permission({
      key: `${GENERAL_KEY}:messages:${Access.READ}`,
      description: 'Nachrichten – Leserecht',
    }),

    WRITE: new Permission({
      key: `${GENERAL_KEY}:messages:${Access.WRITE}`,
      description: 'Nachrichten - Schreibrecht',
    }),
  },
};
